import ContentTitle from "components/common/ContentTitle";
import Loading from "components/common/Loading";
import { useDispatch, useSelector } from "react-redux";

import {
  Table,
  TableBody,
  TableCell,
  TableRow
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import ColorButton from "components/common/ColorButton";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  defaultJobWorkpermitTable,
  getDefaultRow, mapJobWorkpermitTable
} from "libs/utils/form";
import { useEffect } from "react";
import { getDigitalWorkpermitList, selectDigitalWorkpermitList } from "redux/modules/digitalWorkpermitListSlice";
import { getSmartserviceListLTRExtra, selectSmartServiceListLTRExtra } from "redux/modules/visaForm";
import VisaFormService from 'services/VisaFormService';

import { HOME_TAB, LTR_STEP } from "libs/constant/Step";
import { get } from "lodash-es";
import { selectHomeTab, setHomeTab, setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartFormSlice, addWorkPermit, getSmartForm
} from "redux/modules/visaForm";


function DigitalWorkpermitEditorTab() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const modalLoading = useModalLoading();
  const homeTab = useSelector(selectHomeTab);

  const { personalId } = usePersonalDetail();

  const digitalWorkpermitList = useSelector(selectDigitalWorkpermitList)
  const smartServiceListLTRExtras = useSelector(selectSmartServiceListLTRExtra)

  const smartServiceListLTRExtrasData = smartServiceListLTRExtras?.data ?? []
  const hasWorkpermitHistory = digitalWorkpermitList.isSuccess && digitalWorkpermitList?.list?.length > 0 && smartServiceListLTRExtras.isSuccess

  useEffect(() => {
    if (homeTab === HOME_TAB.DIGITAL_WORKPERMIT_EDITOR) {
      dispatch(getDigitalWorkpermitList({ personalId }));
      dispatch(getSmartserviceListLTRExtra())
    }
  }, [homeTab])

  const handleOnAddWPA = async () => {
    const smartServiceAddId = smartServiceListLTRExtrasData?.find((smartService) => smartService.smartserviceName === 'Work Permit Add')?.smartserviceId ?? null

    try {
      modalLoading.showLoading();

      const checkWorkPermitState = await VisaFormService.checkWorkPermit({ personalId, isWorkpermitEditor: true })
      const prepareData = {
        draftId: null,
        smartserviceId: smartServiceAddId,
        personalId,
        survey: null,
        visaissuance: null,
        workpermit: null,
        smartserviceReferId: checkWorkPermitState?.results?.smartserviceReferId ?? null,
        draftIdRef: checkWorkPermitState?.results?.draftIdRef ?? null,
        smartserviceGroupID: "LTR",
        detail: [],
      };
      const response = await dispatch(addWorkPermit({ data: prepareData }));
      await dispatch(getSmartForm({ draftId: response?.payload?.draftId }))
      dispatch(addSmartFormSlice.actions.clearAsyncState());
      modalLoading.hideLoading();
      dispatch(setSmartFormStep(LTR_STEP.UPLOAD_PASSPORT));
      dispatch(
        setHomeTab(HOME_TAB.CHECK_STATUS)
      );
    } catch (error) {
      console.log('error ', error)
      modalLoading.hideLoading();
    }
  }

  const handleOnChangeWPA = async (item) => {
    const smartServiceAddId = smartServiceListLTRExtrasData?.find((smartService) => smartService.smartserviceName === 'Work Permit Change')?.smartserviceId ?? null

    try {
      modalLoading.showLoading();

      const checkWorkPermitState = await VisaFormService.checkWorkPermit({ personalId, isWorkpermitEditor: true })
      const smartformFieldConfig = await VisaFormService.getSmartFormFieldConfig({ smartserviceId: smartServiceAddId, smartserviceGroupID: 'LTR', })

      const defaultType = get(smartformFieldConfig, "results.defaultType", []);
      const documentFields = [
        'dwpHistoryID',
        'position_name_old',
      ]

      const getFieldListConfig = defaultType.filter((field) =>
        documentFields.includes(field.smartName)
      );

      const getValue = (field) => {
        switch (field.smartName) {
          case "dwpHistoryID": {
            return item?.dwpHistoryID ?? null
          }
          case "position_name_old": {
            return item?.jobTitle ?? null
          }
          default:
            return null
        }
      };

      const prepareData = {
        draftId: null,
        smartserviceId: smartServiceAddId,
        personalId,
        survey: null,
        visaissuance: null,
        workpermit: null,
        smartserviceReferId: checkWorkPermitState?.results?.smartserviceReferId ?? null,
        draftIdRef: checkWorkPermitState?.results?.draftIdRef ?? null,
        smartserviceGroupID: "LTR",
        detail: getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: null,
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      };
      const response = await dispatch(addWorkPermit({ data: prepareData }));
      await dispatch(getSmartForm({ draftId: response?.payload?.draftId }))
      dispatch(addSmartFormSlice.actions.clearAsyncState());
      modalLoading.hideLoading();
      dispatch(setSmartFormStep(LTR_STEP.UPLOAD_PASSPORT));
      dispatch(
        setHomeTab(HOME_TAB.CHECK_STATUS)
      );
    } catch (error) {
      console.log('error ', error)
      modalLoading.hideLoading();
    }
  }

  const handleOnRemoveWPA = async (item) => {
    const smartServiceAddId = smartServiceListLTRExtrasData?.find((smartService) => smartService.smartserviceName === 'Work Permit Remove')?.smartserviceId ?? null

    try {
      modalLoading.showLoading();


      const oldSmartVisa = await VisaFormService.getSmartForm({ personalId, draftId: item.draftId })
      const smartform = oldSmartVisa?.results
      const detailList = [
        "WPCompanyRegisterNumber",
        "WPCompanyName",
        "WPCompanyAddress",
        "WPCompanyOfficeNumber",
        "WPCompanyWebsite",
        "WPCompanyProductsServices",
        "WPContractTermType",
        "WPContactPersonInThai",
        "WPContactRelationship",
        "WPContactEmail",
        "WPContactMobile",
        "WPContractYear",
        "WPContractMonth",
        "WPContractOther",
        "WPContractPeriodFrom",
        "WPContractPeriodTo",
        "JobPositionWorkPermit",
        "DesiredWorkingPeriodID",
        "DesiredWorkingPeriodYear",
        "DesiredWorkingPeriodMonth",
        "PeriodStart",
        "PeriodEnd",
        "companyType",
        "emp_idcard_no",
        "emp_fullname",
        "emp_address",
        "emp_province_ddl",
        "emp_district_ddl",
        "emp_subdistrict_ddl",
        "emp_tel",
        "reason",
        "effective_date"
      ];

      const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
      const detail = get(smartform, "detail", [])
        .filter((field) => detailList.includes(field.smartName))
        .reduce(smartNameById, {});

      const values = {
        document: {
          companyType: get(detail, "companyType.value", "C"),
          emp_idcard_no: get(detail, "emp_idcard_no.value", ""),
          emp_fullname: get(detail, "emp_fullname.value", ""),
          emp_address: get(detail, "emp_address.value", ""),
          emp_province_ddl: get(detail, "emp_province_ddl.value", ""),
          emp_district_ddl: get(detail, "emp_district_ddl.value", ""),
          emp_subdistrict_ddl: get(detail, "emp_subdistrict_ddl.value", ""),
          emp_tel: get(detail, "emp_tel.value", ""),

          WPCompanyRegisterNumber: get(
            detail,
            "WPCompanyRegisterNumber.value",
            ""
          ),
          WPCompanyName: get(detail, "WPCompanyName.value", ""),
          WPCompanyAddress: get(detail, "WPCompanyAddress.value", ""),
          WPCompanyOfficeNumber: get(detail, "WPCompanyOfficeNumber.value", ""),
          WPCompanyWebsite: get(detail, "WPCompanyWebsite.value", ""),
          WPCompanyProductsServices: get(
            detail,
            "WPCompanyProductsServices.value",
            ""
          ),
          WPContractTermType: get(detail, "WPContractTermType.value", ""),
          WPContactPersonInThai: get(detail, "WPContactPersonInThai.value", ""),
          WPContactRelationship: get(detail, "WPContactRelationship.value", ""),
          WPContactEmail: get(detail, "WPContactEmail.value", ""),
          WPContactMobile: get(detail, "WPContactMobile.value", ""),
          DesiredWorkingPeriodID: get(detail, "DesiredWorkingPeriodID.value", ""),
          DesiredWorkingPeriodYear: get(
            detail,
            "DesiredWorkingPeriodYear.value",
            ""
          ),
          DesiredWorkingPeriodMonth: get(
            detail,
            "DesiredWorkingPeriodMonth.value",
            ""
          ),
          WPContractYear: get(detail, "WPContractYear.value", ""),
          WPContractMonth: get(detail, "WPContractMonth.value", ""),
          WPContractOther: get(detail, "WPContractOther.value", ""),
          WPContractPeriodFrom: get(detail, "WPContractPeriodFrom.value", ""),
          WPContractPeriodTo: get(detail, "WPContractPeriodTo.value", ""),
          PeriodStart: get(detail, "PeriodStart.value", ""),
          PeriodEnd: get(detail, "PeriodEnd.value", ""),
          JobPositionWorkPermit: getDefaultRow(
            detail,
            "JobPositionWorkPermit.value",
            defaultJobWorkpermitTable
          ).map(mapJobWorkpermitTable),
          reason: get(detail, "reason.value", ""),
          effective_date: get(detail, "effective_date.value", ""),
        }
      }

      const checkWorkPermitState = await VisaFormService.checkWorkPermit({ personalId, isWorkpermitEditor: true })
      const smartformFieldConfig = await VisaFormService.getSmartFormFieldConfig({ smartserviceId: smartServiceAddId, smartserviceGroupID: 'LTR', })

      const defaultType = get(smartformFieldConfig, "results.defaultType", []);
      const documentFields = [
        'dwpHistoryID',
        'remove_type',
        ...detailList,
      ]

      const getFieldListConfig = defaultType.filter((field) =>
        documentFields.includes(field.smartName)
      );

      const getValue = (field) => {
        switch (field.smartName) {
          case "dwpHistoryID": {
            return item?.dwpHistoryID ?? null
          }
          case "remove_type": {
            return `${item?.isMain === true ? 1 : 2}`
          }
          case "reason": {
            return ''
          }
          default:
            return get(values, `document.${field.smartName}`, null);
        }
      };

      const prepareData = {
        draftId: null,
        smartserviceId: smartServiceAddId,
        personalId,
        survey: null,
        visaissuance: null,
        workpermit: null,
        smartserviceReferId: checkWorkPermitState?.results?.smartserviceReferId ?? null,
        draftIdRef: checkWorkPermitState?.results?.draftIdRef ?? null,
        smartserviceGroupID: "LTR",
        detail: getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: null,
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      };
      const response = await dispatch(addWorkPermit({ data: prepareData }));
      await dispatch(getSmartForm({ draftId: response?.payload?.draftId }))
      dispatch(addSmartFormSlice.actions.clearAsyncState());
      modalLoading.hideLoading();
      dispatch(setSmartFormStep(LTR_STEP.UPLOAD_PASSPORT));
      dispatch(
        setHomeTab(HOME_TAB.CHECK_STATUS)
      );
    } catch (error) {
      console.log('error ', error)
      modalLoading.hideLoading();
    }
  }

  const shouldRemoveSingleMain = digitalWorkpermitList.list?.length === 1 && digitalWorkpermitList.list?.some((item) => item.isMain === true)

  return (
    <div>
      <ContentTitle subTitle="" title="Digital Workpermit Editor" />
      {(digitalWorkpermitList.isLoading || smartServiceListLTRExtras.isLoading) && (
        <div style={{ marginTop: 24 }}>
          <Loading />
        </div>
      )}
      {hasWorkpermitHistory && (
        <>
          <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center" style={{ width: 30 }}>
                    No.
                  </StyledTableCell>
                  <StyledTableCell>Job Title</StyledTableCell>
                  <StyledTableCell>Job description</StyledTableCell>
                  <StyledTableCell>Tax ID</StyledTableCell>
                  <StyledTableCell>Company Name</StyledTableCell>
                  <StyledTableCell style={{ width: 200 }}>Address</StyledTableCell>
                  <StyledTableCell>Tel</StyledTableCell>
                  <StyledTableCell>Company Main</StyledTableCell>
                  <StyledTableCell>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {digitalWorkpermitList.list?.map((item, index) => (
                  <TableRow key={index} style={{ verticalAlign: 'top' }}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell>{item?.jobTitle ?? '-'}</TableCell>
                    <TableCell>{item?.job_description ?? '-'}</TableCell>
                    <TableCell>{item?.emp_company_code ?? '-'}</TableCell>
                    <TableCell>{item?.emp_company_name ?? '-'}</TableCell>
                    <TableCell>{item?.emp_address ?? '-'}</TableCell>
                    <TableCell>{item?.emp_tel ?? '-'}</TableCell>
                    <TableCell>{item?.isMain ?? false === true ? 'Yes' : 'No'}</TableCell>
                    <TableCell>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        {item?.isMain === true && <ColorButton fullWidth variant="contained" color="info" onClick={() => handleOnChangeWPA(item)}>Change</ColorButton>}
                        {(item?.isMain === false || shouldRemoveSingleMain) && <ColorButton fullWidth variant="contained" color="error" onClick={() => handleOnRemoveWPA(item)}>Remove</ColorButton>}
                        {(item?.isMain === false) && <ColorButton fullWidth variant="contained" color="error" onClick={() => handleOnRemoveWPA(item)}>Remove</ColorButton>}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

            </Table>
          </TableContainer>
          <div style={{ marginTop: 24, display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <ColorButton style={{ width: 150 }} variant="contained" color="secondary" onClick={handleOnAddWPA}>Add</ColorButton>
          </div>
        </>
      )}
    </div>
  );
}

export default DigitalWorkpermitEditorTab;
